





























































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { TechnicalReportData } from "@/entities";
import LeafRow from "./ProjectImpact/LeafRow.vue";
import Measures from "./ProjectImpact/Measures.vue";
import HeaderInfo from '../../ExpansionPanel/TechExpansionPanel.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';

const namespace: string = "technicalReport";

@Component({
  components: {
    LeafRow,
    Measures,
    HeaderInfo,
    NavButtons
  }
})
export default class ProjectImpact extends Vue {
  @State(namespace) technicalReport!: TechnicalReportData;
  @Getter('grantInfo', {namespace}) grantInfo: any;
  @Getter('selectedReport', {namespace}) report: any;
  @Getter('isStartingPeriod', {namespace}) startingPeriod: boolean;
  @Prop() technicalReportSections: any;
  @Prop() model: any;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() enableButton: any;

  hiddenChild: any = [];

  // get logFrameWork() {
  //   return this.technicalReport.grantData.logframework;
  // }

  get results() {
    return this.model;
  }

  /** show/hide table rows */
  toggleVisibility(data) {
    if (this.hiddenChild.includes(data)) {
      // show hidden row
      const index = this.hiddenChild.indexOf(data);
      this.hiddenChild.splice(index, 1);
    } else {
      this.hiddenChild.push(data); // adding new hidden row
    }
  }

  getFeedbackHeader(rowKey) {
    console.log(this.formOptions.feedbacks)
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }
}
